import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_requeired/help")({
  component: () => <div>Hello /_auth_requeired/help!</div>,
});
